/** Small empty / no-match hint inside manager sidebars (§6.8.8). */
export function SidebarEmptyHint({ children, c }) {
  return (
    <p style={{ padding: "10px 6px", fontSize: 12, color: c.sub, margin: 0, lineHeight: 1.45 }}>
      {children}
    </p>
  );
}
